import { OfferActionTypes } from './actions';
import { UseReducerType } from '../../interfaces';
import { OfferActionType, OffersInterface } from './interfaces';
import { offerInitialState } from './initialState';

export const offerReducer: UseReducerType<OffersInterface, OfferActionType> = (
  state,
  action,
): OffersInterface => {
  switch (action.type) {
    case OfferActionTypes.GetPublishedOffers:
      return {
        ...state,
        publishedOffers: action.payload,
        currentPage: 1,
        hasMore: action.payload.length === 10, // Assume 10 items per page, if less than 10 then no more
      };
    case OfferActionTypes.LoadMorePublishedOffers:
      return {
        ...state,
        publishedOffers: [...state.publishedOffers, ...action.payload],
        currentPage: state.currentPage + 1,
        isLoadingMore: false,
        hasMore: action.payload.length === 10, // If less than 10 offers returned, no more available
      };
    case OfferActionTypes.GetUnpublishedOffers:
      return {
        ...state,
        unpublishedOffers: action.payload,
        currentPage: 1,
        hasMore: action.payload.length === 10, // Assume 10 items per page, if less than 10 then no more
      };
    case OfferActionTypes.LoadMoreUnpublishedOffers:
      return {
        ...state,
        unpublishedOffers: [...state.unpublishedOffers, ...action.payload],
        currentPage: state.currentPage + 1,
        isLoadingMore: false,
        hasMore: action.payload.length === 10, // If less than 10 offers returned, no more available
      };
    case OfferActionTypes.SetLoadingMore:
      return { ...state, isLoadingMore: action.payload };
    case OfferActionTypes.SetHasMore:
      return { ...state, hasMore: action.payload };
    case OfferActionTypes.GetDraftOffers:
      return { ...state, draftOffers: action.payload };
    case OfferActionTypes.UpdatePublishedOffers:
      return { ...state, publishedOffers: [...state.publishedOffers, action.payload] };
    case OfferActionTypes.UpdateDraftOffers:
      return { ...state, draftOffers: [...state.draftOffers, action.payload] };
    case OfferActionTypes.UpdateOfferFilter:
      return {
        ...state, filters: { ...state.filters, ...action.payload }, hasMore: true, currentPage: 1,
      }; // Reset pagination when filters change
    case OfferActionTypes.UpdateCryptoCurrencyRates:
      return { ...state, currencyRate: action.payload };
    case OfferActionTypes.ClearOffers:
      return offerInitialState;

    default:
      return state;
  }
};
